module.exports = __webpack_public_path__ + "static/media/sanchu_icon.be884eb8.svg";